import * as DG from "ui/dialogs"
import { useEffect, useState } from "react"

import AutoCompleteInput from "components/inputs/AutoComplete"
import Button from "ui/buttons/Button"
import { ErrorsMap } from "api/http/utils"
import FormControl from "@material-ui/core/FormControl"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

export type Props = {
  years: number[]
  open: boolean
  onClose: VoidFunction
  onCreate: (value?: string | number | null) => void
}

export const AddYearModal = (props: Props) => {
  const { years, open, onClose, onCreate } = props
  const { t } = useI18n()

  const [year, setYear] = useState<number | null>()
  const [, setErrors] = useState<ErrorsMap | undefined>()

  const handleChange = (value: number | null) => {
    setYear(value)
    // setErrors((e) => ({ ...e, year: "" }))
  }

  const handleSubmit = () => {
    onCreate(year)
  }

  const handleClose = () => {
    setYear(null)
    onClose()
  }

  const id = "create-new-target"

  useEffect(() => {
    if (!open) {
      setYear(null)
      setErrors(undefined)
    }
  }, [open])

  return (
    <DG.Dialog
      className={styles.dialog}
      open={open || false}
      onClose={handleClose}
      id={id}
      disableEscapeKeyDown
      keepMounted
      BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.3)" } }}
    >
      <DG.DialogHeader>
        <DG.DialogTitle id={id}>
          <div className={styles.title}>
            <p className={"HeadlineH5BlackBold"}>
              {t("market.universe.create.title")}
            </p>
            <p className={"BodyBody-1BlackLight"}>
              {t("market.universe.create.subtitle")}
            </p>
          </div>
        </DG.DialogTitle>

        <DG.DialogClose onClose={handleClose} />
      </DG.DialogHeader>

      <DG.DialogContent className={styles.content}>
        <div className={styles.inputWrapper}>
          <FormControl variant="outlined">
            <div>
              <AutoCompleteInput<number | null>
                key={year}
                label={t("market.universe.input.type")}
                size="medium"
                margin="normal"
                options={years || []}
                onChange={handleChange}
                getOptionSelected={(option, value) => option === value}
                renderOption={(option) => <span>{option}</span>}
                getOptionLabel={(option) => `${option}`}
                value={year}
                fetchOnFilter={false}
                className={styles.input}
                type="number"
              />
            </div>
          </FormControl>
        </div>
      </DG.DialogContent>
      <DG.DialogFooter>
        <DG.DialogActions>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            {t("market.universe.button.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            form="new_member"
            onClick={handleSubmit}
            //disabled={!canCreate}
          >
            {t("market.universe.button.add")}
          </Button>
        </DG.DialogActions>
      </DG.DialogFooter>
    </DG.Dialog>
  )
}

const styles = {
  inputWrapper: css`
    margin-right: auto;
  `,
  input: css`
    min-width: 255px;
  `,
  content: css`
    padding: var(--spacing-m) 0 var(--spacing-xl) var(--spacing-xl);
  `,
  autocomplete: css`
    margin-bottom: var(--spacing-xs);
  `,
  dialog: css`
    max-width: 551px;
    margin: auto;
  `,
  title: css`
    display: flex;
    flex-direction: column;
  `,
}
